import { FormGroup, Input } from "reactstrap";
import RequiredTitle from "../../../elements/RequiredTitle";

interface Props {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  description: string;
  setDescription: React.Dispatch<React.SetStateAction<string>>;
  setPageNumber?: React.Dispatch<React.SetStateAction<number>>;
}

export default function ViewInfoSection({
  name,
  setName,
  description,
  setDescription,
  setPageNumber,
}: Props) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setPageNumber && !!name && setPageNumber((prev) => prev + 1);
      }}
    >
      <FormGroup>
        <RequiredTitle title="Name" size="md" />
        <Input
          autoFocus
          placeholder="Name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          bsSize="sm"
          className="mb-4"
        />
        <h4>Description</h4>
        <Input
          placeholder="What this view will be used for (optional)"
          type="textarea"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          bsSize="sm"
        />
      </FormGroup>
    </form>
  );
}
